export const COMPONENTES_CATALOGO = Object.freeze([
  'CatalogoLocalDeTrabalho',
  'CatalogoEmpregador',
  'CatalogoEmpregado',
  'CatalogoGrupoDeLocaisDeTrabalho',
  'CatalogoPerfilDePermissao',
  'CatalogoUsuario',
  'CatalogoMotivoPadrao',
  'CatalogoRegraDeCalculo',
])

export const ehComponenteSeletorImaginii = (nome: string): boolean => (
  nome === 'PontotelSeletor' || COMPONENTES_CATALOGO.includes(nome)
)

const ehRegistro = (valor: unknown): valor is Record<string, unknown> => (
  typeof valor === 'object' && valor !== null && !Array.isArray(valor)
)

export const valorDoSeletorEstaPreenchido = (
  valor: unknown,
  componente: string,
): boolean => {
  if (componente === 'PontotelSeletor') {
    return ehRegistro(valor)
      && Array.isArray(valor.selecionados)
      && valor.selecionados.length > 0
  }
  if (COMPONENTES_CATALOGO.includes(componente)) {
    return Array.isArray(valor) ? valor.length > 0 : ehRegistro(valor)
  }
  return false
}

